import clsx from 'clsx'
import { motion } from 'framer-motion'

export default function Card({ hover = false, className, children, ...props }) {
  const Comp = hover ? motion.div : 'div'
  const hoverProps = hover
    ? { whileHover: { y: -2, boxShadow: 'var(--elev-3)' }, transition: { duration: 0.2, ease: [0.16, 1, 0.3, 1] } }
    : {}
  return (
    <Comp
      className={clsx(
        'rounded-lg border border-line bg-panel shadow-elev1',
        className
      )}
      {...hoverProps}
      {...props}
    >
      {children}
    </Comp>
  )
}
